<template>
  <div style="font-size: 0">
    <!-- <Banner /> -->
    <img src="https://admin.gdyfpt.com/file/pic/20201228120212284784.jpg" class="cover-image" />
    <div class="main-content" v-if="false">
      <div class="content-title">走进我们</div>
      <div class="content-title-en">About us</div>
      <div class="article-content" v-html="info.titleContent">
        <!-- <div class="base-info">广东友丰油茶科技有限公司，是一家致力打造全国最大的油茶种植服务商和有机茶油加工商。
公司依托位于山清水秀的广铁集团粤海北梅村林场1.2万亩优质林地资源，集“种、养、产、学、研”为一体，以低温冷榨纯茶油为主打产品，高端珍惜家禽为增值产品，以23栋别墅，各种户外活
动做配套服务，着力打造集观光休闲、独家娱乐、山体运动于一体的综合旅游城市新名片——“韶关市茶花森林公园”。</div>
        <div class="base-info">经过多年的努力，2015年荣获“广东省林业龙头企业“和”广东省油茶工程技术研究中心“，2016年荣获”韶关市农业龙头企业“和”韶关市科普教育基地“及”韶关市插画森林公园“、”浈江
区友丰湿地公园“，2017年、2018年荣获”广东省农业产业化重点龙头企业“、”广东省高新技术产业“、”广东省森林康养基地“、”广东省扶贫龙头企业“、”韶关市浈江区油茶省级现代农
业产业园“等殊誉。形成把油茶种植、加工、观赏结合一体化的油茶产业链。</div>
        <div class="part-title">我们的使命</div>
        <div class="part-title-en">Our Mission</div>
        <div class="base-info" style="padding-top: 30px;">以油茶产业为契机，融入中华民族复兴之梦。
打造公司+基地（合作社）+会员+贫困家庭的精准扶贫脱贫新模式。
促进山川不在荒芜，老幼不再孤独，家庭不再贫苦。</div>
        <div class="part-title">我们的愿景</div>
        <div class="part-title-en">Our Vision</div>
        <div class="base-info" style="padding-top: 30px;">成为全国最大油茶种植服务商和有机茶油加工服务商，
打造中国家庭高端植物油第一品牌。</div>
        <div class="part-title">发展历程</div>
        <div class="part-title-en">development history</div>
        <div class="develop-history" style="padding-top: 30px;">
          <div class="history-item" v-for="(item, index) in history" :key="index">
            <span class="year">{{item.year}}</span>
            <span class="month">{{item.month}}</span>
            <span>{{item.content}}</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  loadYxTitle
} from '@/api/api'
import Banner from '../../components/Banner'
export default {
  components: {
    Banner
  },
  data() {
    return {
      info: {
        titleContent: ''
      },
      history: [
        {
          year: 2020,
          month: 3,
          content: '我公司董事长张克文被授予”广东省百名景气企业家“荣誉称号。'
        },
        {
          year: 2020,
          month: 1,
          content: '荣获”广东省林下经济示范基地“。'
        },
        {
          year: 2019,
          month: 11,
          content: '舜然鲜山茶油荣获“2019年广东神名牌产品（农业类）”。'
        },
        {
          year: 2019,
          month: 10,
          content: '荣获“广东省扶贫农业龙头企业”殊荣。'
        },
        {
          year: 2019,
          month: 3,
          content: '我公司董事长张克文被授予”广东省百名景气企业家“荣誉称号。'
        },
        {
          year: 2019,
          month: 7,
          content: '荣获“韶关市浈江区油茶省级现代农业产业园”。'
        },
        {
          year: 2019,
          month: 3,
          content: '荣获”广东省森林康养基地“（全省十家之一）。'
        },
        {
          year: 2019,
          month: 1,
          content: '荣获”广东省重点农业龙头企业“，荣获”省级科普教育基地“殊荣。'
        },
        {
          year: 2018,
          month: 12,
          content: '荣获”韶关市三星级乡村旅游民宿“，”韶关市文明单位“殊荣。'
        },
        {
          year: 2018,
          month: 12,
          content: '我公司佛那个市长张克文荣获2017年韶关市”最可爱的脱贫攻坚人“的荣誉称号，荣获全市精准扶贫行动”先进民营企业“称号。'
        },
        {
          year: 2018,
          month: 11,
          content: '荣获”全国高新技术企业“殊荣。'
        },
        {
          year: 2018,
          month: 6,
          content: '荣获”守合同重信誉单位“殊荣。'
        },
        {
          year: 2018,
          month: 3,
          content: '荣获”广东省农业公园“。'
        },
        {
          year: 2017,
          month: 1,
          content: '韶关市茶花森林公园获得”2017年度全省休闲农业与乡村旅游示范点“称号。'
        },
        {
          year: 2017,
          month: 12,
          content: '荣获”韶关市文明单位“、”韶关市科普教育基地“殊荣。'
        },
        {
          year: 2017,
          month: 11,
          content: '”舜然鲜山茶油“荣获”广东省名特鲜新农产品“殊荣。'
        },
        {
          year: 2016,
          month: 1,
          content: '值韶关市异地商会联席会议第二次会议盛大召开之际，在活动中，友丰舜然鲜山茶油隆重宣布上市，品牌知名度及曝光度得到大幅度提升。'
        },
        {
          year: 2015,
          month: '',
          content: '友丰茶油被评为”广东省林业龙头企业“和”广东省茶油工程技术研究中心“，形成把茶油种植、加工、观赏结合一体化的茶油产业链。'
        },
        {
          year: 2014,
          month: 6,
          content: '友丰茶油引进了先进的精炼全套现代化生产设备，建成拥有产能2000吨的现代化茶油精深加工生产工厂。'
        },
        {
          year: 2020,
          month: 6,
          content: '友丰科研人员与农科所的专家合作，致力于对茶油资源的可持续开发。'
        }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      loadYxTitle().then(res => {
        var data = res.content.find(item => {
          return item.titleType == 0
        })
        if(data) {
          this.info = data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .cover-image {
    width: 100%;
  }
  .main-content {
    width: 1200px;
    padding-top: 80px;
    margin: 0 auto;
    .content-title {
      line-height: 42px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 2px;
      text-align: center;
    }
    .content-title-en {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      color: #999999;

      text-align: center;
      &::before {
        content: "—— ";
      }
      &::after {
        content: " ——";
      }
    }
    .article-content {
      width: 100%;
      padding-top: 50px;
      .base-info {
        width: 100%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #333333;
        margin-bottom: 25px;
      }
      .develop-history {
        .history-item {
          line-height: 30px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-bottom: 40px;
          &:last-child {
            margin: 0;
          }
          .year {
            font-size: 18px;
            font-family: Microsoft YaHei;
            color: #333333;
            margin-right: 2px;
            &::after {
              content: "年";
            }
          }
          .month {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            margin-right: 40px;
            &::after {
              content: "月";
            }
          }
        }
      }
    }
  }
</style>